// extracted by mini-css-extract-plugin
export default {"wrapper":"fullPageError_wrapper__qlmYS"};